module.exports = __webpack_public_path__ + "img/logo-gestão-pessoas.0e4fd531.svg";